module.exports = "/images/hi.svg";